// Bella Vita frontend — tiny DOM helpers.
// Ported from design-v2/js/preview.js so component code keeps returning real
// DOM nodes (no string-concat rendering, no framework).

/** Build an element from a trimmed HTML string; returns the first child. */
export function el(html) {
  const t = document.createElement('template');
  t.innerHTML = String(html).trim();
  return t.content.firstElementChild;
}

export const $ = (sel, root = document) => root.querySelector(sel);
export const $$ = (sel, root = document) =>
  Array.prototype.slice.call(root.querySelectorAll(sel));

/** Delegated listener: fires fn(event, matchedEl) when e.target is inside `sel`. */
export function on(node, ev, sel, fn) {
  node.addEventListener(ev, (e) => {
    const m = e.target.closest(sel);
    if (m && node.contains(m)) fn(e, m);
  });
}

/** Replace all children of `mount` with `node`. */
export function mount(mountNode, node) {
  mountNode.replaceChildren(node);
}

/** Escape text for safe interpolation into an el() template string. */
export function esc(s) {
  return String(s ?? '').replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
  }[c]));
}
